<template>
  <div class="fancy-info">
    <div class="fancy-info__icon">?</div>
    <div class="fancy-info__text" v-html="text"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
  },
  methods: {},
};
</script>